import { render, staticRenderFns } from "./fullGiveActivity.vue?vue&type=template&id=d67a9716&"
import script from "./fullGiveActivity.vue?vue&type=script&lang=js&"
export * from "./fullGiveActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d67a9716')) {
      api.createRecord('d67a9716', component.options)
    } else {
      api.reload('d67a9716', component.options)
    }
    module.hot.accept("./fullGiveActivity.vue?vue&type=template&id=d67a9716&", function () {
      api.rerender('d67a9716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/oilActivityManage/fullGiveActivity/fullGiveActivity.vue"
export default component.exports